import { UserManager } from 'oidc-client-ts';
import { oidcConfig } from './constants';


export const userManager = new UserManager(oidcConfig);
